{
  "version": "1.2.6",
  "objects": {
    "7430093515436806654": {
      "type": "frame",
      "id": "7430093515436806654",
      "z": 7303,
      "textContent": "",
      "left": -1058.9060742361248,
      "top": 2398.794932714212,
      "width": 400,
      "height": 500,
      "scaleX": 0.7694665816350448,
      "scaleY": 0.09858628735634853,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7430093515439234509": {
      "type": "frame",
      "id": "7430093515439234509",
      "z": 7130,
      "textContent": "Frame 96",
      "left": -1009.6129305579506,
      "top": 2411.441504553299,
      "width": 400,
      "height": 500,
      "scaleX": 0.5630779820215777,
      "scaleY": 0.05,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515436806654",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430093515437746096": {
      "type": "shape",
      "id": "7430093515437746096",
      "z": 7131,
      "shapeName": "text",
      "textContent": "<p>Information banner description</p>",
      "left": -1009.6129305579506,
      "top": 2411.441504553299,
      "width": 199.5,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7430093515439234509",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430093515439125255": {
      "type": "wireframe",
      "id": "7430093515439125255",
      "z": 7132,
      "top": 2409.294932714212,
      "left": -1048.9060742361248,
      "width": 52,
      "height": 52,
      "scaleX": 0.5633296861187359,
      "scaleY": 0.5633296861187359,
      "container": "7430093515436806654",
      "layoutPosition": "Zzzzzx",
      "wireframeName": "avatar",
      "fill": "#0073CF",
      "textColor": "#333333",
      "style": "square",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "circle-info" },
        "iconRight": null
      },
      "showBackground": true,
      "showOutline": true
    },
    "7430093515441394963": {
      "type": "shape",
      "id": "7430093515441394963",
      "z": 7133,
      "shapeName": "icon",
      "textContent": "",
      "left": -774.3817377493194,
      "top": 2415.731667619529,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.10262296167212569,
      "scaleY": 0.10262296167212569,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#BDBDBD",
      "angle": 0,
      "container": "7430093515436806654",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    }
  }
}
